import React from 'react'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'

const UploadSuccessOrFailureMessage = ({ documentTypeName, responseMessage }) => <div>
  {responseMessage === 'Y' && <LgyAlertDialog type='success' heading='Upload Success' role='alert' text={`Successfully uploaded ${documentTypeName}`} />}
  {responseMessage === 'N' && <LgyAlertDialog type='error' heading='Upload Error' role='alert' text={`Failed to upload ${documentTypeName}`} />}
  {responseMessage !== 'Y' && responseMessage !== 'N' && <LgyAlertDialog type='error' role='alert' heading='Upload Error' text={responseMessage} />}
</div>

export default UploadSuccessOrFailureMessage
